import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { getTenants, getTenant, createTenant, updateTenant } from '@lingaai/supabase-client';
import type { Tenant } from '@lingaai/types';

export function useTenants() {
  return useQuery({
    queryKey: ['tenants'],
    queryFn: () => getTenants(),
  });
}

export function useTenant(tenantId: string) {
  return useQuery({
    queryKey: ['tenants', tenantId],
    queryFn: () => getTenant(tenantId),
    enabled: !!tenantId,
  });
}

export function useCreateTenant() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (data: { name: string; workspace_slug: string; workspace_email: string }) => createTenant(data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['tenants'] });
    },
  });
}

export function useUpdateTenant() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ tenantId, updates }: { tenantId: string; updates: Partial<Tenant> }) => updateTenant(tenantId, updates),
    onSuccess: (_, variables) => {
      queryClient.invalidateQueries({ queryKey: ['tenants'] });
      queryClient.invalidateQueries({ queryKey: ['tenants', variables.tenantId] });
    },
  });
}
